module.exports = __webpack_public_path__ + "static/media/iconrightwhite.32667d1f.svg";